function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 4");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: 2.02,
  transform: "translate(-293.000000, -23.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(293.000000, 22.000000)"
}, React.createElement("path", {
  d: "M25.2807543,20.0360279 L25.2807543,29.9346405 L12.9274382,21.6892702 L5.13667089,21.6892702 L5.13667089,11.9050116 L3.63809427e-10,9.83163083 L2.5825748,6.70431688 L33,18.9820947 L30.4174252,22.1094086 L25.2807543,20.0360279 Z M14.7670639,8.06324154 L25.2807543,1.04575163 L25.2807543,12.307018 L14.7670639,8.06324154 Z",
  id: "Combined-Shape"
}))));

var SvgSoundOff = function SvgSoundOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "33px",
    height: "29px",
    viewBox: "0 0 33 29",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSoundOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound-off.deeacdd9.svg";
export { ForwardRef as ReactComponent };